import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';
import { UseFilterValuesType, UseOptionsQueryParams } from '@/components/FilterNew/types';
import { OrgRoleTypeEnum } from '@/types/schema';

import useFilterOptionsQuery from '../../hooks/useFilterOptionsQuery';
import useFilterValue from '../../hooks/useFilterValue';
import { useOrgRoleFilterQuery } from './graphql/query/generated/orgRoleFilter';
import { getOrgRoleFilterOption } from './utils';

export interface UseOrgRoleOptionsQueryParams {
  trackIds?: string[];
  type?: OrgRoleTypeEnum[];
}

const edgeKey = 'orgRoles';

const DESIGNATION_TYPE_FILTER = [OrgRoleTypeEnum.Designation];

const useOptionsQuery = ({
  searchText,
  trackIds,
  type = DESIGNATION_TYPE_FILTER,
}: UseOptionsQueryParams & UseOrgRoleOptionsQueryParams) =>
  useFilterOptionsQuery({
    useQuery: useOrgRoleFilterQuery,
    edgeKey,
    variables: { filters: { name: searchText, trackIds, type } },
    getFilterOption: getOrgRoleFilterOption,
  });

const useFilterValues: UseFilterValuesType = ({ value }) =>
  useFilterValue({
    value,
    useQuery: useOrgRoleFilterQuery,
    edgeKey,
    variables: { filters: { ids: value } },
    getFilterOption: getOrgRoleFilterOption,
  });

export const OrgRoleEntityConfig: FilterBodyListConfig<{ trackIds?: string[] }> = {
  listVariant: 'multi-ungrouped-infinite',
  useOptionsQuery,
  useFilterValues,
};
